import { TPatientActions, TPatientsState } from '../../types/patients';

export const patientActionTypes = {
  GET_PATIENT_DETAIL_REQUEST: 'PATIENTS/GET_DETAIL_REQUEST',
  GET_PATIENT_DETAIL_SUCCESS: 'PATIENTS/GET_DETAIL_SUCCESS',
  GET_WAITING_REQUEST: 'PATIENTS/GET_WAITING_REQUEST',
  GET_WAITING_SUCCESS: 'PATIENTS/GET_WAITING_SUCCESS',
} as const;

const initialState: TPatientsState = {
  patientDetail: null,
};

export default (state: TPatientsState = initialState, action: TPatientActions): TPatientsState => {
  switch (action.type) {
    case patientActionTypes.GET_WAITING_SUCCESS:
      return {
        ...state,
        waiting: action.payload,
      };

    case patientActionTypes.GET_PATIENT_DETAIL_SUCCESS:
      return {
        ...state,
        patientDetail: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  getWaitingRequest: () => ({ type: patientActionTypes.GET_WAITING_REQUEST }),
  getPatientDetailRequest: (providerId: string, id: string) => ({
    payload: {
      providerId,
      id,
    },
    type: patientActionTypes.GET_PATIENT_DETAIL_REQUEST,
  }),
};
